import Contract from '../common/Contract';
import ContractItem from '../common/ContractItem';
import ContractItemForm from "../common/ContractItem/Form";
import ContractForm from '../common/Contract/ContractForm';
import WorkExperience from './WorkExperience';
import WorkExperienceForm from './WorkExperience/Form';
import WorkAbsence from './WorkAbsence';
import WorkAbsenceForm from './WorkAbsence/Form';

const path = '/dashboard/data/work';

const routes = [
  {
    name: 'Contract',
    path: `${path}/contract`,
    icon: 'user',
    component: Contract,
    exact:true,
  },
  {
    name: 'Contract Form',
    path: [
      `${path}/contract/create`,
      `${path}/contract/:id`,
      `${path}/contract/:id/update`,
    ],
    exact: true,
    icon: 'user',
    component: ContractForm,
    hide: true,
  },
  {
    name: 'Contract Form Item',
    path: [
      `${path}/contract-item/create`,
      `${path}/contract-item/:id`,
      `${path}/contract-item/:id/update`,
    ],
    exact: true,
    icon: 'user',
    component: ContractItemForm,
    hide: true,
  },
  {
    name: "Work Experience",
    path: `${path}/experience`,
    icon: "user",
    component: WorkExperience,
    exact: true,
  },
  {
    name: "Work Experience Form",
    path: [
      `${path}/experience/create`,
      `${path}/experience/:id`,
      `${path}/experience/:id/update`,
    ],
    icon: "user",
    component: WorkExperienceForm,
    exact: true,
  },
  {
    name: "Work Absence",
    path: `${path}/work-absence`,
    icon: "user",
    component: WorkAbsence,
    exact: true,
  },
  {
    name: "Work Absence Form",
    path: [
      `${path}/work-absence/create`,
      `${path}/work-absence/:id`,
      `${path}/work-absence/:id/update`,
    ],
    icon: "user",
    component: WorkAbsenceForm,
    exact: true,
  },
];

export const redirects = [
  {
    from: `${path}`,
    to: `${path}/experience`,
  },
  {
    from: `${path}/*`,
    to: `${path}/experience`,
  },
];

export default routes;
